import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Credits/api/FloatingAccountsQuery").then(r => {
        commit("setList", r.data.data);
      });
    },
    fetchChildsData({ commit, dispatch } , id ) {
      return ajax.get(`Credits/api/FloatingAccountsQuery/get-all-child-accounts/${id}`).then(r => {

        commit("setList", r.data);
        return r.data;
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Credits/api/FloatingAccounts", model).then(() => {
        dispatch("fetch");
      }).catch((e) => {
      });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Credits/api/FloatingAccounts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Credits/api/FloatingAccounts/assign-connected-accounts", model).then(() => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
